module.exports = __webpack_public_path__ + "static/media/triangle_back.f62b4213.png";